import React, { CSSProperties, useContext, useEffect, useState } from "react";
import "./styles.less";
import { useRouter } from "next/router";
import { firstLetterToUppercase } from "src/utils/Functions";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

export const Arrow = ({ className, style }: { className?: string, style?:CSSProperties }) => (
	<svg
		className={className}
		width="18"
		height="18"
		viewBox="0 0 18 18"
		style={style}
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M6.75 14.25L11.25 9.75L6.75 5.25"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const OptionsLabel = ({ onOptionClick }: { onOptionClick: (option: string) => void }) => {
	const { translations, country_code } = useContext(ConfigStateContext);
	const OptionsLabelAboutUs = [
		{
			label: firstLetterToUppercase(translations.contáctanos),
			link: "contactanos",
		},
		{
			label: "Anuncia con nosotros",
			link: "anuncia-con-nosotros",
		},
		country_code === "CO" && {
			label: "Recomendaciones de Seguridad",
			link: "recomendaciones-de-seguridad",
		},
		{
			label: "Preguntas Frecuentes",
			link: "preguntas-frecuentes",
		},
	];
	const LegalLabels = [
		{
			label: "Aviso Legal",
			link: "aviso-legal",
		},
		{
			label: "Términos y Condiciones",
			link: "terminos-y-condiciones",
		},
		{
			label:
				country_code === "CO"
					? "Políticas de tratamiento de datos"
					: "Políticas de Privacidad",
			link: "politicas-de-privacidad",
		},
		country_code === "CO" && {
			label: "Políticas de Cookies",
			link: "politicas-de-cookies",
		},
	];
	const [activeLabel, setActiveLabel] = useState<string | null>("contactanos");
	const { asPath, isReady } = useRouter();

	useEffect(() => {
		const handleHashChange = () => {
			const currentUrl = window.location.href;
			const url = new URL(currentUrl);
			const hash = url.hash;
			const hashWithoutSharp = hash.replace("#", "");

			if (hashWithoutSharp) {
				setActiveLabel(hashWithoutSharp);
			} else {
				setActiveLabel("contactanos");
			}
		};

		window.addEventListener("hashchange", handleHashChange);

		return () => {
			window.removeEventListener("hashchange", handleHashChange);
		};
	}, []);

	useEffect(() => {
		if (isReady) {
			const path = asPath.split('#');
			path.length > 1 && setActiveLabel(path[1]);
		}
	}, [isReady, asPath]);

	const handleLabelClick = (link: string) => {
		if (link !== activeLabel) {
			setActiveLabel(link === activeLabel ? null : link);
		}
	};

	return (
		<div className="optionsLabel">
			<h1 className="optionsLabel__title">Acerca de nosotros</h1>
			<ul className="optionsLabel__list">
				{OptionsLabelAboutUs.map((item, index) => {
					const isActive = item.link === activeLabel;

					if (item) {
						return (
							<li
								key={`${item.link}-${index}`}
								className={`optionsLabel__list__option ${isActive ? "labelActive" : ""
									}`}>
								<a
									href={`#${item.link}`}
									onClick={(e) => {
										e.preventDefault();
										onOptionClick(item.link);
										handleLabelClick(item.link);
									}}>
									<span>{item.label}</span>
									<Arrow />
								</a>
							</li>
						);
					}
				})}
			</ul>
			<h2 className="optionsLabel__title">Legales</h2>
			<ul className="optionsLabel__list">
				{LegalLabels.map((item, index) => {
					const isActive = item.link === activeLabel;

					if (item) {
						return (
							<li
								key={`${item.link}-${index}`}
								className={`optionsLabel__list__option ${isActive ? "labelActive" : ""
									}`}>
								<a
									href={`#${item.link}`}
									onClick={(e) => {
										e.preventDefault();
										onOptionClick(item.link);
										handleLabelClick(item.link);
									}}>
									<span>{item.label}</span>
									<Arrow />
								</a>
							</li>
						);
					}
				})}
			</ul>
		</div>
	);
};

export default OptionsLabel;

